import { MediaPayload, MediaPayloadMediaType } from "@swivl-mono/types";
import React from "react";

import { ListItemData } from "../../ListItem";
import "./Media.scss";

const parseVideo = function (url) {
  url.match(
    /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
  );
  let type;
  if (RegExp.$3.indexOf("youtu") > -1) {
    type = "youtube";
  } else if (RegExp.$3.indexOf("vimeo") > -1) {
    type = "vimeo";
  }
  return {
    type: type,
    id: RegExp.$6
  };
};

const getVideoThumbnail = function (url, cb) {
  // Obtains the video's thumbnail and passed it back to a callback function.
  var videoObj = parseVideo(url);
  if (videoObj.type == "youtube") {
    cb("//img.youtube.com/vi/" + videoObj.id + "/maxresdefault.jpg");
  } else if (videoObj.type == "vimeo") {
    // Requires jQuery
    fetch("http://vimeo.com/api/v2/video/" + videoObj.id + ".json").then((data) => {
      cb(data[0].thumbnail_large);
    });
  }
};
export interface MediaProps {
  item: ListItemData;
  width: number;
}
export interface MediaState {
  src: any | undefined;
  imageWidth: number;
  imageHeight: number;
}

export class Media extends React.Component<MediaProps, MediaState> {
  image: HTMLImageElement;

  constructor(props: MediaProps) {
    super(props);
    this.image = new Image();
    this.state = { src: null, imageWidth: 0, imageHeight: 0 };
    var self = this;
    this.image.onload = function () {
      self.setState({ src: self.image.src, imageWidth: (this as any).naturalWidth, imageHeight: (this as any).naturalHeight });
    };
    this.adjustedImageSize = this.adjustedImageSize.bind(this);
  }
  componentDidMount() {
    if (this.props.item && this.props.item.message && (this.props.item.message.payload as MediaPayload).mediaType == MediaPayloadMediaType.Video) {
      getVideoThumbnail((this.props.item.message.payload as MediaPayload).mediaURL, (thumbURL) => {
        this.image.src = thumbURL;
      });
    } else {
      this.image.src = (this.props.item.message.payload as MediaPayload).mediaURL;
    }
  }
  adjustedImageSize() {
    if (this.props.width && this.state.imageWidth && this.state.imageHeight) {
      if (this.state.imageWidth < this.props.width - 85) {
        return { width: this.state.imageWidth, height: this.state.imageHeight };
      }
      const scale = (this.props.width - 85) / this.state.imageWidth;
      return { width: this.state.imageWidth * scale, height: this.state.imageHeight * scale };
    }
    return null;
  }
  render() {
    const item: any = this.props.item;

    const adjustedImageSize = this.adjustedImageSize();
    const sizeStyle = adjustedImageSize
      ? { width: adjustedImageSize.width + "px", height: adjustedImageSize.height + "px" }
      : { width: "30px", height: "18px", maxHeight: "30px" };
    const content = this.state.src ? (
      <img src={this.state.src} className="scc-mediaImage" style={sizeStyle} />
    ) : (
      <div className="scc-typingIndicator fromImage">
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
    if ((this.props.item.message.payload as MediaPayload).mediaType == MediaPayloadMediaType.Video) {
      return (
        <div className="scc-Media" style={sizeStyle}>
          <a target="_blank" href={(this.props.item.message.payload as MediaPayload).mediaURL}>
            {content}
          </a>
        </div>
      );
    }
    return (
      <div className="scc-Media" style={sizeStyle}>
        {content}
      </div>
    );
  }
}
